module.exports = __webpack_public_path__ + "img/tongzhi.93281bd3.png";